import Base from '@studiometa/js-toolkit';

/**
 * Hero class.
 */
export default class Hero extends Base {
  /**
   * Class cofnig
   * @return {Object}
   */
  static config = {
    name: 'Hero',
    refs: ['images[]'],
  };

  activeIndex = 0;

  maxIndex = 0;

  /**
   * Mounted
   */
  mounted() {
    if (!this.$refs.images || this.$refs.images.length <= 1) {
      return;
    }

    this.interval = setInterval(
      this.nextImage,
      this.$options.interval ? this.$options.interval : 4000
    );

    this.maxIndex = this.$refs.images.length;
  }

  /**
   * Clean up
   */
  destroyed() {
    clearInterval(this.interval);
  }

  /**
   * Handle the image change
   * @return {void}
   */
  nextImage() {
    this.activeIndex += 1;

    if (this.activeIndex >= this.maxIndex) {
      this.activeIndex = 0;
    }

    this.$refs.images.forEach((img) => {
      img.classList.add('absolute', 'opacity-0');
    });

    this.$refs.images[this.activeIndex].classList.remove('absolute', 'opacity-0');
  }
}
